var jQuery = $;

$(document).ready(function() { 

  $(".hamburger").click(function() {
    $(this).toggleClass("is-active");
    $("nav.navigation").toggleClass("active");
  });

  // Transform close icon back to hamburger icon
  $("nav.navigation a").click(function() {
    $(".hamburger").removeClass("is-active");
  });

  // Transform close icon back to hamburger icon and close nav by clicking outside nav
  $("content").click(function() {
    $(".hamburger").removeClass("is-active");
  	$("nav.navigation").removeClass("active");
  });

  // Add breakpoints
  var isBreakPoint = function (bp) {
  var bps = [300, 768, 20000],
      w = $(window).width(),
      min, max
  for (var i = 0, l = bps.length; i < l; i++) {
    if (bps[i] === bp) {
      min = bps[i-1] || 0
      max = bps[i]
      break
    }
  }
    return w > min && w <= max
  }

  // Breakpoint <= 768px
  if (isBreakPoint(768)) { 
    $('.navigation a').click(function (e) {
      $("nav.navigation").removeClass("active");
    });

    $('[data-scroll]').on('click', scrollTo);
    $(document).on('scroll', scrollWatcher);
    var elements = [];
    var menuHeight = 0;

    // Add smooth scrolling to all links <= 768px
    $("a").on('click', function(event) {
        if (this.hash !== "") {
          event.preventDefault();
          var hash = this.hash;

          $('html, body').animate({
            scrollTop: $(hash).offset().top
          }, 800, function(){
            window.location.hash = hash;
          });
        }
    });

    $(window).scroll(function (event) {
      var scrollBottom = $(window).scrollTop() + $(window).height();
        $('#cta-container').toggleClass('remove',
        //add 'remove' class when div position match or exceeds else remove the 'remove' class.
        scrollBottom >= $('#contact').offset().top
      );
    });
  }

  // Breakpoint > 768px
  if (isBreakPoint(20000)) { 
    $('[data-scroll]').on('click', scrollTo);
    $(document).on('scroll', scrollWatcher);
    var elements = [];
    var menuHeight = 44;

    // Add smooth scrolling to all links > 768px
    $('a').not('.cta').on('click', function(event) {
        if (this.hash !== "") {
          event.preventDefault();
          var hash = this.hash;

          $('html, body').animate({
            scrollTop: $(hash).offset().top - 45
          }, 800, function(){
            window.location.hash = hash;
          });
        }
    });

     $(".cta").on('click', function(event) {
        if (this.hash !== "") {
          event.preventDefault();
          var hash = this.hash;

          $('html, body').animate({
            scrollTop: $(hash).offset().top
          }, 800, function(){
            window.location.hash = hash;
          });
        }
    });

    $(window).scroll(function (event) {
      var scrollBottom = $(window).scrollTop();
      $('#header').toggleClass('remove',
       //add 'remove' class when div position match or exceeds else remove the 'remove' class.
        scrollBottom >= ($('#contact').offset().top - 50)
      );
  });


  }

  // open FAQ accordion on click
  $('.faq-toggle').click(function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.faq .inner').removeClass('show');
        $this.parent().parent().find('.faq .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
  });

  // Set the element data
  if (elements.length == 0) {
      $('[data-scroll]').each(function(index, element) {
          elements.push({
              target: $(element),
              name: $(element).data('scroll').replace('#', ''),
              top: (index == 0 ? 0 : $($(element).data('scroll')).offset().top - menuHeight),
              height: $($(element).data('scroll')).height()
          });
      });
  }

  function scrollTo(e) {
      e.preventDefault();
      var scrollTop = ($(e.target).parent().index() == 0 ? 0 : $($(e.target).data('scroll')).offset().top - menuHeight);
      $('html, body').stop().animate({'scrollTop': scrollTop}, 500, 'swing', function () {
          $(document).on('scroll', scrollWatcher);
      });
  }

  function scrollWatcher(e) {
      // Get current scroll position
      var scrollPos = $(document).scrollTop() + 5;
      elements.forEach(function(element) {
          if (element.top <= scrollPos && element.top + element.height >= scrollPos) {
              $('[data-scroll]').removeClass('active');
              element.target.addClass('active');
          } else {
              element.target.removeClass('active');
          }
      });
  }

  // Remove class when page scroll reaches specific id
 
  // Trigger the scroll
  $(window).scroll();//ensure if you're in current position when page is refreshed

  
}); 